/**
 *
 * RootContainer
 *
 */

import { Container, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import styles from './styles';

function RootContainer({ classes, children }) {
  return <Container className={classes.root}>{children}</Container>;
}

RootContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withStyles(styles)(memo(RootContainer));
